import { HttpRequest } from './HttpRequest';
import { tasasCrediseguroUrl, baseUrl } from 'utils/ApiRoutes';

const url = `${baseUrl}${tasasCrediseguroUrl.tasas}`;

export const getTasas = async (): Promise<IGetTasasResponse> => {
  try {
    const response = await new HttpRequest().Get<IGetTasasResponse>(url);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener las tasas CrediSeguro');
  }
};

export const createTasa = async (
  payload: ITasaCrediSeguroPayload
): Promise<ICreateTasaResponse> => {
  try {
    const response = await new HttpRequest().Post<ICreateTasaResponse>(url, payload);
    return response.data;
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error('Error al crear la tasa CrediSeguro');
  }
};

export const updateTasa = async (
  id: number,
  payload: Partial<ITasaCrediSeguroPayload>
): Promise<IUpdateTasaResponse> => {
  try {
    const response = await new HttpRequest().PutWithAuth<IUpdateTasaResponse>(
      `${url}/${id}`,
      payload
    );
    return response.data;
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error('Error al actualizar la tasa CrediSeguro');
  }
};

export const deleteTasa = async (id: number): Promise<IDeleteTasaResponse> => {
  try {
    const response = await new HttpRequest().Delete<IDeleteTasaResponse>(`${url}/${id}`);
    return response.data;
  } catch (error) {
    if (error instanceof Error) throw error;
    throw new Error('Error al eliminar la tasa CrediSeguro');
  }
};
